export function isEnumMember<T extends string, TEnumValue extends string>(
  value: string,
  enumVariable: {
    [key in T]: TEnumValue;
  },
): value is TEnumValue {
  const enumValues = Object.values(enumVariable);
  return enumValues.includes(value);
}
